// extracted by mini-css-extract-plugin
export default {"kontener":"TrescWydruku_kontener__3l81z","przycisk":"TrescWydruku_przycisk__GQ6Ap","ha3":"TrescWydruku_ha3__T6veE"};